import {
  retry,
  stopAfterAttempt,
  waitExponential,
} from "@/services/RetryService.js";

export function setTrackingPathsHubspot(path) {
  var _hsq = (window._hsq = window._hsq || []);
  _hsq.push(["setPath", path]);
  _hsq.push(["trackPageView"]);
}

export function setPathDefaultHubSpotTrack() {
  var _hsq = (window._hsq = window._hsq || []);
  _hsq.push(["setPath", "/"]);
  _hsq.push(["trackPageView"]);
}

export function loadHubspotScript(projectId) {
  const project = projectId || process.env.VUE_APP_HUBSPOT_SUITE_PROJECT_ID;
  const srcHubspot = `//js.hs-scripts.com/${project}.js`;
  const scriptElement = document.createElement("script");
  scriptElement.src = srcHubspot;
  scriptElement.type = "text/javascript";
  scriptElement.id = "hs-script-loader";
  scriptElement.async = true;
  scriptElement.defer = true;

  window.hsConversationsSettings = {
    loadImmediately: false,
  };

  document.body.appendChild(scriptElement);
}

export function identifyUserOnHubSpot(currentUser) {
  var _hsq = (window._hsq = window._hsq || []);
  const user_data = {
    email: currentUser.email,
    firstName: currentUser.first_name,
    lastName: currentUser.last_name,
    company: currentUser.domain,
  };
  _hsq.push(["identify", user_data]);
}

async function loadOrRefreshHubspotChat() {
  if (window.__HUBSPOT_CHAT_DISABLED) {
    console.warn(
      "HubSpot chat previously detected as disabled — skipping open."
    );
    return;
  }

  const hasScript = !!document.getElementById("hs-script-loader");
  const hasHubSpotObj = !!window.HubSpotConversations;
  const hasWidget = !!window.HubSpotConversations?.widget;

  if (hasScript && (!hasHubSpotObj || !hasWidget)) {
    window.__HUBSPOT_CHAT_DISABLED = true;
    console.warn(
      "HubSpot chat appears disabled or unavailable for this portal."
    );
    return;
  }

  const status = await retry(
    async () => {
      try {
        return window.HubSpotConversations?.widget?.status?.();
      } catch (e) {
        window.__HUBSPOT_CHAT_DISABLED = true;
        console.warn("HubSpot chat error detected, marking as disabled:", e);
        return undefined;
      }
    },
    {
      stop: stopAfterAttempt(10),
      wait: waitExponential({ min: 3000, max: 1000 }),
      retry: (result) => {
        if (window.__HUBSPOT_CHAT_DISABLED) return false;
        return !result;
      },
    }
  );

  if (window.__HUBSPOT_CHAT_DISABLED) return;

  if (status && typeof status.loaded !== "undefined") {
    if (status.loaded) {
      try {
        window.HubSpotConversations.widget.refresh();
      } catch (e) {
        console.error("hubspot: failed to refresh widget:", e);
      }
    } else {
      try {
        window.HubSpotConversations.widget.load();
      } catch (e) {
        console.error("hubspot: failed to load widget:", e);
      }
    }
  }
}

export function removeHubSpotChat() {
  if (!window.HubSpotConversations?.widget) return;

  window.HubSpotConversations.widget.remove();
}

export function openHubSpotChat() {
  if (!window.HubSpotConversations?.widget) return;

  window.HubSpotConversations.widget.open();
}

export function setHubSpotChatIdentification(email, token) {
  if (
    window.hsConversationsSettings.identificationEmail == email &&
    window.hsConversationsSettings.identificationToken == token
  ) {
    return;
  }
  window.hsConversationsSettings = {
    identificationEmail: email,
    identificationToken: token,
  };
}

export function setChatParams(isSalesChat) {
  const currentUrl = new URL(window.location.href);
  const searchParams = new URLSearchParams(currentUrl.search);

  if (isSalesChat) {
    searchParams.set("sales_chat", "true");
    searchParams.delete("success_chat");
  } else {
    searchParams.set("success_chat", "true");
    searchParams.delete("sales_chat");
  }
  window.history.pushState(
    {},
    "",
    `${currentUrl.pathname}?${searchParams.toString()}`
  );
}

export async function handleHubspotChatLoad(email, token, isSalesChat) {
  setHubSpotChatIdentification(email, token);
  setChatParams(isSalesChat);
  await loadOrRefreshHubspotChat();
  openHubSpotChat();
}
